import React, { useState } from "react";
import { useEffect } from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Redirect, useHistory, useParams } from "react-router-dom";
import * as commondata from "../../Common";
import { Button } from "../UI";
const CustomFilter = (props) => {
  const params = useParams();
  const togglemenu = useSelector((state) => state.boardAttribute.toggleMenu);
  const [state, setState] = useState({
    system_filter: [],
    user_filter: [],
    reports: [],
  });

  const history = useHistory();
  function getSelectedId() {
    if (props.isKanban) {
      const getId = localStorage.getItem("selected_filter");
      if (getId && commondata.IsJsonString(getId)) {
        const newidconvert = JSON.parse(getId);
        return newidconvert[params.attribute_set_key];
      }
      return getId?.[params.attribute_set_key] || "";
    } else {
      const getId = localStorage.getItem("selected_filter");
      if (getId && commondata.IsJsonString(getId)) {
        const newidconvert = JSON.parse(getId);

        if(params.second_attribute_set_key){
          setTimeout(() => {
           localStorage.removeItem("selected_filter");
          }, 1000);
          return '';
        }
        
        return newidconvert[params.attribute_set_key];
      }

      return getId?.[params.attribute_set_key] || getId;
    }
  }
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        system_filter: props.filters?.system_filter ?? [],
        user_filter: props.filters?.user_filter ?? [],
        reports: props.filters?.reports ?? [],
      };
    });
  }, [
    props.filters?.user_filter,
    props.filters?.system_filter,
    props.filters?.reports,
  ]);
  
  function getSelectedItem(item, target = '') {
    // const getfilterid = getSelectedId();
    // props.getFilteredObj(item);
      history.push(`/tattle/${item.attribute_set_key === "projects" ? "er" : item.attribute_set_key}/list${target ? '/'+ target : ''}`, {
        filterdata: item,
      });
    if (props.isView) {
      return;
    }
    props.getFilteredObj(item);
  }

  function editFilterHandler(id, type) {
    const { filters } = props;
    if (type === "system") {
      const valid = state.system_filter.find((item) => item.filter_id === id);
      props.enebleClickFilter(null, valid, true, id);
      return;
    }
    const valid = state.user_filter.find((item) => item.filter_id === id);
    if (valid.hasOwnProperty("filter_type")) {
      if (valid.filter_type) {
        props.enebleAdvancedClickFilter(null, valid, true, id);
      } else {
        props.enebleClickFilter(null, valid, true, id);
      }
    }
  }

  function deleteFilter(id, filter_type) {
    props.removeFilterHandler(id, filter_type);
  }

  function createFilter() {
    props.enebleClickFilter();
  }
  function createAdvancedFilter() {
    props.enebleAdvancedClickFilter();
  }
  function getReports(val) {
    if (val) {
      const selectedFilter = localStorage.getItem("selected_filter");
      if (selectedFilter && commondata.IsJsonString(selectedFilter)) {
        let newfilterval = {
          ...JSON.parse(selectedFilter),
          [params.attribute_set_key]: val,
        };

        localStorage.setItem("selected_filter", JSON.stringify(newfilterval));
      }
      history.push({
        pathname: `/tattle/${params.attribute_set_key === "projects" ? "er" : params.attribute_set_key}/report/${val}`,
      });
    }

    return;
  }
  return (
    <div
      className={`border-0 custom_filter_class mt-3 ${
        togglemenu && "custom_filter_hide"
      }`}
    >
      <Button className="muBtn create_filter_btn" onClick={createFilter}>
        Create View
      </Button>
      <br />
      {!props.isKanban && props.isAdmin ? (
        <a className="advFilter" onClick={createAdvancedFilter}>
          <svg
            stroke="currentColor"
            fill="none"
            stroke-width="0"
            viewBox="0 0 15 15"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z"
              fill="currentColor"
            ></path>
          </svg>{" "}
          Advance Filter
        </a>
      ) : (
        ""
      )}
      {state.system_filter.length ? (
        <div className="system_defined_view mt-4">
          <span className="filter_heading">System Views</span>
          <ul className="filter_menu mb-4 mt-2">
            {state.system_filter?.map((item, index) => {
              let config = {};

              try {
                config = typeof item.config === "string" ? JSON.parse(item.config) : item.config;
              } catch (err) {
                console.error("Invalid config JSON:", err);
              }
              const target = config?.target || '';
              return (
                <li
                  key={index}
                  className={`filter_menu_child mb-2 ${
                    (item.filter_id == getSelectedId(target ?? false) || target == params.second_attribute_set_key || target== params.attribute_set_key) ? "active" : ""
                  }`}
                >
                  <span onClick={() => getSelectedItem(item, target)}>
                    {item.filter_name}{" "}
                  </span>{" "}
                  {/* <div className="filter_option_action float-end">
                  <span
                    className="float-end filter-edit"
                    onClick={() => deleteFilter(item.filter_id)}
                  >
                    <i className="fa fa-trash"></i>
                  </span>
                  <span
                    className="float-end filter-edit"
                    onClick={() => editFilterHandler(item.filter_id)}
                  >
                    <i className="fa fa-pencil"></i>
                  </span>
                </div> */}
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        ""
      )}
      <hr />

      {state.reports.length ? (
        <div className="system_defined_view">
          <span className="filter_heading">Reports</span>
          <ul className="filter_menu mb-4 mt-2">
            {state.reports.map((it) => (
              <li
                className={`filter_menu_child mb-2 ${
                  it?.filter_value === getSelectedId() &&
                  props.hasOwnProperty("board_title") &&
                  props.board_title
                    ? "active"
                    : ""
                }`}
              >
                <span onClick={() => getReports(it?.filter_value)}>
                  {it?.filter_name}
                </span>
              </li>
            ))}

            {/*<li className="filter_menu_child mb-2">
                <span onClick={() => getReports('releases')}>
                    Release
                </span>
            </li>*/}
          </ul>
        </div>
      ) : (
        ""
      )}
      <hr />

      {state.user_filter.length ? (
        <div className={`custom_view ${props.className}`}>
          <span className="filter_heading">Custom Views</span>
          <ul className="filter_menu filter_menu_two mt-2">
            {state.user_filter?.map((item, index) => {
              return (
                <li
                  key={index}
                  className={`filter_menu_child mb-2 ${
                    item.filter_id == getSelectedId() ? "active" : ""
                  }`}
                >
                  <OverlayTrigger
                    key={"filter-list"}
                    placement={"top"}
                    overlay={
                      <Tooltip id={`filter-name`}>
                        <strong> {item?.filter_name}</strong>
                      </Tooltip>
                    }
                  >
                    <span onClick={() => getSelectedItem(item)}>
                      {item.filter_name.length > 15
                        ? item.filter_name.slice(0, 15) + "..."
                        : item.filter_name}{" "}
                    </span>
                  </OverlayTrigger>

                  {!props.isView && (
                    <div className="hover_menu_dot">
                      <div class="dropdown">
                        <a
                          class="dropdownhyperlink"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <svg
                            width="19"
                            height="18"
                            viewBox="0 0 19 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.6673 7.3502C10.6673 7.01882 10.3987 6.7502 10.0673 6.7502C9.73591 6.7502 9.46729 7.01882 9.46729 7.3502C9.46729 7.68158 9.73591 7.9502 10.0673 7.9502C10.3987 7.9502 10.6673 7.68158 10.6673 7.3502Z"
                              fill="#5A738E"
                              stroke="#5A738E"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M5.41729 7.3502C5.41729 7.01882 5.14865 6.7502 4.81729 6.7502C4.48592 6.7502 4.21729 7.01882 4.21729 7.3502C4.21729 7.68158 4.48592 7.9502 4.81729 7.9502C5.14865 7.9502 5.41729 7.68158 5.41729 7.3502Z"
                              fill="#5A738E"
                              stroke="#5A738E"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M15.9173 7.3502C15.9173 7.01882 15.6487 6.7502 15.3173 6.7502C14.9859 6.7502 14.7173 7.01882 14.7173 7.3502C14.7173 7.68158 14.9859 7.9502 15.3173 7.9502C15.6487 7.9502 15.9173 7.68158 15.9173 7.3502Z"
                              fill="#5A738E"
                              stroke="#5A738E"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </a>
                        <ul
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li>
                            <span
                              class="dropdown-item"
                              onClick={() =>
                                editFilterHandler(item.filter_id, "custom")
                              }
                            >
                              <span className="dropdown-icon-child">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_1975_42073)">
                                    <path
                                      d="M11.3335 1.99955C11.5086 1.82445 11.7165 1.68556 11.9452 1.5908C12.174 1.49604 12.4192 1.44727 12.6668 1.44727C12.9145 1.44727 13.1597 1.49604 13.3884 1.5908C13.6172 1.68556 13.8251 1.82445 14.0002 1.99955C14.1753 2.17465 14.3142 2.38252 14.4089 2.61129C14.5037 2.84006 14.5524 3.08526 14.5524 3.33288C14.5524 3.58051 14.5037 3.8257 14.4089 4.05448C14.3142 4.28325 14.1753 4.49112 14.0002 4.66622L5.00016 13.6662L1.3335 14.6662L2.3335 10.9996L11.3335 1.99955Z"
                                      stroke="#666666"
                                      stroke-width="1.33"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_1975_42073">
                                      <rect
                                        width="16"
                                        height="16"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>{" "}
                              Edit
                            </span>
                          </li>
                          <li>
                            <span
                              class="dropdown-item"
                              onClick={() =>
                                deleteFilter(item.filter_id, item.filter_type)
                              }
                            >
                              <span className="dropdown-icon-child">
                                <svg
                                  width="17"
                                  height="16"
                                  viewBox="0 0 17 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2.96582 4H4.29915H14.9658"
                                    stroke="#5C5F62"
                                    stroke-width="1.33"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M6.29932 3.99967V2.66634C6.29932 2.31272 6.43979 1.97358 6.68984 1.72353C6.93989 1.47348 7.27903 1.33301 7.63265 1.33301H10.2993C10.6529 1.33301 10.9921 1.47348 11.2421 1.72353C11.4922 1.97358 11.6326 2.31272 11.6326 2.66634V3.99967M13.6327 3.99967V13.333C13.6327 13.6866 13.4922 14.0258 13.2421 14.2758C12.9921 14.5259 12.6529 14.6663 12.2993 14.6663H5.63265C5.27903 14.6663 4.93989 14.5259 4.68984 14.2758C4.43979 14.0258 4.29932 13.6866 4.29932 13.333V3.99967H13.6327Z"
                                    stroke="#5C5F62"
                                    stroke-width="1.33"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M7.63232 7.33301V11.333"
                                    stroke="#5C5F62"
                                    stroke-width="1.33"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.2993 7.33301V11.333"
                                    stroke="#5C5F62"
                                    stroke-width="1.33"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>{" "}
                              </span>
                              Delete
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  )}
                  <div className="filter_option_action float-end">
                    {/* {!params.id && (
                    <>
                      <span
                        className="float-end filter-edit"
                        onClick={() => deleteFilter(item.filter_id)}
                      >
                        <i className="fa fa-trash"></i>
                      </span>
                      <span
                        className="float-end filter-edit"
                        onClick={() =>
                          editFilterHandler(item.filter_id, "custom")
                        }
                      >
                        <i className="fa fa-pencil"></i>
                      </span>
                    </>
                  )} */}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomFilter;
